import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/images/bg.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/images/icon_1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/images/icon_2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/images/icon_3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/images/icon_4.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/images/icon_5.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/images/icon_6.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/images/icon_7.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/images/icon_8.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/images/img4.webp");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/BannerSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/Downloads.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/FaqsMain.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/MainSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/SessionContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/VolunteerCommunity.tsx");
